import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SrodekTrwalyService } from '../../@core/http/srodek-trwaly.service';
import { SumowanieKwotService } from '../../@core/utils';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../@core/utils/komunikaty-tabeli.service';
import { SrodekTrwaly } from '../../shared/models/srodek-trwaly.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-srodki-trwale',
  templateUrl: './srodki-trwale.component.html',
  styleUrls: ['./srodki-trwale.component.scss'],
})
export class SrodkiTrwaleComponent implements OnInit, OnDestroy {

  @ViewChild('hdrTpl', { static: true }) hdrTpl: TemplateRef<any>;

  dane: SrodekTrwaly[];
  temp = [];
  eksportKolumny = [];
  eksportPdfKolumnyStyle;
  zakresDat: ZakresDat;
  private srodekTrwalySubscription: Subscription;
  wyswietlanieFiltrow = false;

  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly srodekTrwalyService: SrodekTrwalyService,
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
    ) {}

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());

    this.odswiezKolumnyPdf();
    this.translate.onLangChange.subscribe(() => this.odswiezKolumnyPdf());
  }

  ngOnDestroy(): void {
    if (this.srodekTrwalySubscription) {
      this.srodekTrwalySubscription.unsubscribe();
    }
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this.dane = temp;
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.srodekTrwalySubscription = this.srodekTrwalyService
      .getSrodkiTrwale(zakresDat)
      .subscribe(response => {
        this.temp = [...response];
        this.dane = response;
      });
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function(d) {
      return (d.nazwa != null && d.nazwa.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.dataZakupu != null && d.dataZakupu.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.przyczynaZbycia != null && d.przyczynaZbycia.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this.dane = temp;
  }

  sumaWartoscPoczatkowa(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.wartoscPoczatkowa || 0), 0);
  }

  sumaAmortyzacjaMiesieczna(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.amortyzacjaMiesieczna || 0), 0);
  }

  sumaAmortyzacjaJednorazowa(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.amortyzacjaJednorazowa || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  private odswiezKolumnyPdf() {
    this.eksportKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa'},
      {header: this.translate.instant('etykieta.nazwa'), dataKey: 'nazwa'},
      {header: this.translate.instant('etykieta.data-zakupu'), dataKey: 'dataZakupu'},
      {header: this.translate.instant('etykieta.wartosc-poczatkowa'), dataKey: 'wartoscPoczatkowa'},
      {header: this.translate.instant('etykieta.amortyzacja-miesieczna'), dataKey: 'amortyzacjaMiesieczna'},
      {header: this.translate.instant('etykieta.amortyzacja-jednorazowa'), dataKey: 'amortyzacjaJednorazowa'},
      {header: this.translate.instant('etykieta.miesiac-poczatkowy'), dataKey: 'miesiacPoczatkowy'},
      {header: this.translate.instant('etykieta.miesiac-koncowy'), dataKey: 'miesiacKoncowy'},
      {header: this.translate.instant('etykieta.data-zbycia'), dataKey: 'dataZbycia'},
      {header: this.translate.instant('etykieta.przyczyna-zbycia'), dataKey: 'przyczynaZbycia'},
    ];

    this.eksportPdfKolumnyStyle = {
      liczbaPorzadkowa: { halign: 'right' },
      wartoscPoczatkowa: { halign: 'right' },
      amortyzacjaMiesieczna: { halign: 'right' },
      amortyzacjaJednorazowa: { halign: 'right' },
    };
  }

}
